import * as types from '../types';

export default {
  [types.GET_CRM_USERS](state, data) {
    state.crmUsers = data;
  },
  [types.GET_TEAM_LIST](state, data) {
    state.crmTeams = data;
  },
  [types.GET_PARENT_TEAM_LIST](state, data) {
    state.parentTeams = data;
  },
  [types.GET_TEAM_MEMBERS](state, data) {
    state.teamMembers = data;
  },
  [types.GET_RECORDS](state, data) {
    state.records = data;
  },
  [types.GET_DICTIONARY_LIST](state, data) {
    state.dictionaryList = data;
  },
  [types.GET_DICTIONARY_DETAIL_LIST](state, data) {
    state.dictionaryDetailList = data;
  },
  [types.GET_DICTIONARY_DETAIL](state, data) {
    state.dictionaryDetail = data;
  },
  [types.GET_TEAM_CONFIG_LIST](state, data) {
    state.teamConfigList = data;
  },
  [types.GET_SECOND_TEAM_LIST](state, data) {
    state.secondTeamList = data;
  },
  [types.GET_ALL_CATEGORY_LIST](state, data) {
    state.allCategoryList = data;
  },
  [types.GET_ALL_DICTIONARY_LIST](state, data) {
    state.allDictionaryList = data;
  },
  [types.GET_TEAM_CONFIG_DETAIL](state, data) {
    state.teamConfigDetail = data;
  },
  [types.GET_TEAM_CHANGE](state, data) {
    state.teamChangeList = data;
  },
  [types.GET_ROLE_LIST](state, data) {
    state.roleList = data;
  },
  [types.GET_ROLE_USER_LIST](state, data) {
    state.roleUserList = data;
  },
  [types.GET_MENU_TREE_LIST](state, data) {
    state.menuTreeList = data;
  },
  [types.GET_PRODUCT_LIST](state, data) {
    state.productList = data;
  },
};
